<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">选择科室</div>
            <el-select v-model="edit_DepartmentId" placeholder="请选择科室" style="width: 100%">
              <el-option
                  v-for="item in department_arr"
                  :key="item.id"
                  :label="item.departmentClassName+'/'+item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">岗位名称</div>
            <el-input v-model="edit_Name" placeholder="请输入岗位名称" ></el-input>
          </el-col>

        </el-row>
        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">排序</div>
            <el-input v-model="edit_sort" placeholder="请输入排序" ></el-input>
          </el-col>
        </el-row>

      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Edit',
  props: [],
  data() {
    return {

      loading: false,

      edit_Name:'',
      edit_sort:'',
      //edit_status:'',
      edit_DepartmentId:'',
      //edit_JobClassTypeCode:'',
      jobClassId:'',

      department_arr:[],
      //class_type_arr:[],


      status_arr:[{value:1,label:'正常'},{value:2,label:'禁用'}],


    }
  },
  methods: {
    init(row){

      this.edit_Name = row.name;
      this.edit_sort = row.sort;
      //this.edit_status = row.status;
      this.edit_DepartmentId = row.departmentId;
      //this.edit_JobClassTypeCode = row.jobClassTypeCode;

      this.jobClassId=row.id;

      this.getDepartment();
      //this.getClassType();

    },

    closeSelf() {
      this.loading= false
      this.$emit("closeEdit");
    },


    getDepartment(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Department/AdmList',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          //status:-1,
        }

      }).then( (response)=> {
        if(response.data.error == 0){
          this.department_arr = response.data.data.list;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },

    getClassType(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'JobClassType/AdmList',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }

      }).then( (response)=> {
        if(response.data.error == 0){
          this.class_type_arr = response.data.data.list;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },



    confirm(){

      if(this.edit_Name === ''){
        this.$message("输入岗位名称");
        return;
      }
      if(this.edit_DepartmentId === '' || this.edit_DepartmentId == null){
        this.$message("选择科室");
        return;
      }

      if(this.edit_sort === ''){
        this.$message("输入排序");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'JobClass/AdmEdit',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name: this.edit_Name,
          sort:this.edit_sort,
          //status:this.edit_status,
          departmentId:this.edit_DepartmentId,
          //jobClassTypeCode:this.edit_JobClassTypeCode,
          jobClassId:this.jobClassId,
        }
      }).then( (response)=> {
        //console.log(response)
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeEdit");
          this.$emit("getList");
        }else{
          this.$message(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>

